import { Link, Outlet } from "react-router-dom";
import { Typography, Container, TextField, Switch, InputAdornment, InputLabel, FormControl, OutlinedInput, IconButton, Box, Toolbar, AppBar, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import globe from '../../assets/images/globe.svg'
import globelist from '../../assets/images/globelist.svg'
import proifleimg from '../../assets/images/proifleimg.png'
import carpark from '../../assets/images/car-parking.svg'
import tabhome from '../../assets/images/tabhome.svg'
import account from '../../assets/images/account.svg'
import support from '../../assets/images/support.svg'
import applepay from '../../assets/images/applepay.svg'
import { FaCalendarAlt, FaParking, FaCreditCard } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Mappage = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Container>

        <div className="app-container ">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <div>Past Parking Sessions</div>
            <div className=" visablityhidden"><button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button> </div>

          </header>

  {/* Sort & Filter Buttons */}
  <div className="container px-3">
  <div className="d-flex justify-content-between align-items-center mt-3 gx-0 filter">
              <button className="btn btn-light btn-sm dropdown-toggle border-1" onClick={handleShow} style={{ width: "110px" }}>Sort By</button>
              <button className="btn btn-light btn-sm  border-1" style={{ width: "110px" }}>
                <i className="bi bi-funnel"></i> Filters
              </button>
              <div>
              <ButtonGroup aria-label="Basic example" className="filter  btn-sm">
                  {/* <Link to="/pastpark"></Link> */}
                  <Button className=" btn-light " onClick={() => navigate("/pastpark")} > <img
                    src={globelist}
                    alt="Parking Spot"
                    className="rounded" style={{ width: "22px" }}
                  /> </Button>
                  <Button className=" btn-light active" onClick={() => navigate("/mappage")} > <img
                    src={globe}
                    alt="Parking Spot"
                    className="rounded" style={{ width: "22px" }}
                  /> </Button>
                  {/* <Link to="/mappage"> </Link> */}
                </ButtonGroup>

              </div>
            </div></div>

            {/* Parking Sessions List */}
            <div className="map-container  mt-2">
            <div className="marker" style={{ top: "40%", left: "60%" }}></div>
        <div className="marker" style={{ top: "50%", left: "50%" }}></div>
        <div className="marker" style={{ top: "60%", left: "40%" }}></div>
        <div className="marker" style={{ top: "55%", left: "70%" }}></div>
            <iframe
      title="Google Map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509087!2d144.9630577153165!3d-37.81410797975154!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0x5045675218ce6e0!2sMelbourne%20VIC%2C%20Australia!5e0!3m2!1sen!2sus!4v1648701119123!5m2!1sen!2sus"
      width="600"
      height="1000"
      style={{ border: 0 }}
      allowFullScreen className="map-img"
      loading="lazy"
    ></iframe>
            </div>
{/* 
          <Container className="mt-0 px-3" style={{ minHeight:"calc(100vh - 136px)"}}>
          

          </Container> */}

          {/* Bottom Navigation */}
          <nav className="bottom-nav d-flex justify-content-around align-items-center py-2">
            <div className="nav-item "><Link to="/homepage">
              <img
                src={tabhome}
                alt="Parking Spot"
                className="rounded" style={{ width: "24px" }}
              /><br></br>
              <span>Home</span></Link>
            </div>
            <div className="nav-item active" ><Link to="/pastpark">
              <img
                src={carpark}
                alt="Parking Spot"
                className="rounded" style={{ width: "24px" }}
              /><br></br>
              <span>Past Parkings</span></Link>
            </div>
            <div className="nav-item"><Link to="/account">
              <img
                src={account}
                alt="Parking Spot"
                className="rounded" style={{ width: "24px" }}
              /><br></br>
              <span>Account</span></Link>
            </div>
            <div className="nav-item"><Link to="/supportpage">
              <img
                src={support}
                alt="Parking Spot"
                className="rounded" style={{ width: "24px" }}
              /><br></br>
              <span>Support</span></Link>
            </div>
            <div className="nav-item"><Link to="/profile">
              <img
                src={proifleimg}
                alt="Profile"
                className="rounded-circle"
              /><br></br>
              <span>Profile</span></Link>
            </div>
          </nav>


          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Sort</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="list-group">
                <label className="d-flex align-items-center mb-3">
                  <input
                    type="radio"
                    name="sort"
                    className="form-check-input me-2"
                  />
                  <span >
                    Newest
                  </span>
                </label>
                <label className="d-flex align-items-center mb-3">
                  <input
                    type="radio"
                    name="sort"
                    className="form-check-input me-2"
                  />
                  <span >
                    Oldest
                  </span>
                </label>
                <label className="d-flex align-items-center mb-3">
                  <input
                    type="radio"
                    name="sort"
                    className="form-check-input me-2"
                  />
                  <span >
                    Less Distance
                  </span>
                </label>
                <label className="d-flex align-items-center">
                  <input
                    type="radio"
                    name="sort"
                    className="form-check-input me-2"
                  />
                  <span >
                    More Distance
                  </span>
                </label>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex p-3">
              <Button className="w-50 btn-light">
                Reset Filter
              </Button>
              <Button className="w-50 btn-brand-1 font-bold">
                Apply
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </Container>


    </>
  );
};

export default Mappage;
